<template lang="html">
  <div class="root">
    {{msg}}
  </div>
</template>

<script>
export default {
  data(){
    return {
      msg:'Hello Home'
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Home.vue?0a64076d